<template>
  <Plugin
    from="m/platform/plugin/common"
    name="app-update"
    :props="{}"
    :emit="{
      onReady: bindCheckUpdate,
    }"
  />
</template>
<script setup>
import { usePluginReadyEmit } from "app-core";
import { onMounted } from "vue";
const [checkUpdate, bindCheckUpdate] = usePluginReadyEmit();

onMounted(() => {
  checkUpdate();
});
</script>
